export const NAMES = {
    'AIR 3218 B78Y 2LB4HBp 1.5m': 'Interleaved AIR 3218',
    'Interleaved AIR 6418 B78Y 2LB4HBp 2.6m': 'Interleaved AIR 6418',
    'Radio mounted antenna, with Radio 4471HP': 'Radio mounted antenna',
    'Street Sector 6522': 'Street Sector',
    'Indoor Fusion Unit 8828': 'Indoor Fusion Unit',
    'Solar Shelf 6670': 'Solar Shelf',
    'GRU 05 01': 'GNSS Synchronization',
    'Voltage Booster 6640': 'Voltage Booster'
}